export default "__VITE_ASSET__BMOe_q1g__"